import React from "react";
import { toast } from "react-toastify";
import BellImage from "../../assets/bell-not.svg";
import styles from "./notificationToast.module.scss";

const AUTO_CLOSE = 6000;

const ToastContent = ({ details, matterRef }) => (
  <div>
    <div className={styles.details}>{details}</div>
    {matterRef && <div className={styles.matter}>{matterRef}</div>}
  </div>
);

export const showNotificationToast = (payload) => {
  if (!payload?.details) return;

  toast(<ToastContent details={payload.details} matterRef={payload.matterRef} />, {
    autoClose: AUTO_CLOSE,
    icon: <img src={BellImage} alt="" className={styles.icon} />,
    className: styles.toast,
    bodyClassName: styles.body,
  });
};
